import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import Home from '../pages/Home'
import ScrollToTop from '../components/ScrollToTop'
import { TOOLS } from '../constants/tools'

// Lazy-loaded pages — har page apni alag chunk file mein split hogi,
// homepage load karte waqt sirf homepage ka code download hoga
const AgePage = lazy(() => import('../pages/AgePage'))
const ChronologicalAgeCalculatorPage = lazy(() => import('../pages/ChronologicalAgeCalculatorPage'))
const PetAgeCalculatorPage = lazy(() => import('../pages/PetAgeCalculatorPage'))
const EligibilityCalculatorPage = lazy(() => import('../pages/EligibilityCalculatorPage'))
const GenerationCalculatorPage = lazy(() => import('../pages/GenerationCalculatorPage'))
const IslamicAgeCalculatorPage = lazy(() => import('../pages/IslamicAgeCalculatorPage'))
const RetirementAgeCalculatorPage = lazy(() => import('../pages/RetirementAgeCalculatorPage'))
const WordCounterPage = lazy(() => import('../pages/WordCounterPage'))
const ImageCompressorPage = lazy(() => import('../pages/ImageCompressorPage'))
const ImageConverterPage = lazy(() => import('../pages/ImageConverterPage'))
const PasswordPage = lazy(() => import('../pages/PasswordPage'))
const PercentagePage = lazy(() => import('../pages/PercentagePage'))
const YtThumbnailPage = lazy(() => import('../pages/YtThumbnailPage'))
const TextToSpeechPage = lazy(() => import('../pages/TextToSpeechPage'))
const QrGeneratorPage = lazy(() => import('../pages/QrGeneratorPage'))
const JsonFormatterPage = lazy(() => import('../pages/JsonFormatterPage'))
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('../pages/TermsOfService'))
const AboutUs = lazy(() => import('../pages/AboutUs'))
const Contact = lazy(() => import('../pages/Contact'))
const BlogListingPage = lazy(() => import('../pages/BlogListingPage'))
const BlogPostPage = lazy(() => import('../pages/BlogPostPage'))
const FAQPage = lazy(() => import('../pages/FAQPage'))
const HelpPage = lazy(() => import('../pages/HelpPage'))
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'))

const IncreasePercentage = lazy(() => import('../pages/IncreasePercentage'))
const DecreasePercentage = lazy(() => import('../pages/DecreasePercentage'))
const DiscountCalculator = lazy(() => import('../pages/DiscountCalculator'))
const TaxCalculator = lazy(() => import('../pages/TaxCalculator'))
const TipCalculator = lazy(() => import('../pages/TipCalculator'))
const MarksPercentage = lazy(() => import('../pages/MarksPercentage'))
const GpaCalculator = lazy(() => import('../pages/GpaCalculator'))
const Layout = () => {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<div className="page-loading" style={{ minHeight: '60vh' }} />}>
        <Outlet />
      </Suspense>
    </>
  )
}

// ... baaki poora router config WAISA HI RAHEGA (routes array mein koi change nahi)

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home tools={TOOLS} />,
      },
      {
        path: 'age',
        element: <AgePage tools={TOOLS} />,
      },
      // CALCULATOR ROUTES
      {
        path: 'chronological-age-calculator',
        element: <ChronologicalAgeCalculatorPage tools={TOOLS} />,
      },
      {
        path: 'pet-age-calculator',
        element: <PetAgeCalculatorPage tools={TOOLS} />,
      },
      {
        path: 'eligibility-calculator',
        element: <EligibilityCalculatorPage tools={TOOLS} />,
      },
      {
        path: 'generation-calculator',
        element: <GenerationCalculatorPage tools={TOOLS} />,
      },
      {
        path: 'islamic-age-calculator',
        element: <IslamicAgeCalculatorPage tools={TOOLS} />,
      },
      {
        path: 'retirement-age-calculator',
        element: <RetirementAgeCalculatorPage tools={TOOLS} />,
      },

      // OTHER TOOL ROUTES
      {
        path: 'word-counter',
        element: <WordCounterPage tools={TOOLS} />,
      },
      {
        path: 'image-compressor',
        element: <ImageCompressorPage tools={TOOLS} />,
      },
      {
        path: 'image-converter',
        element: <ImageConverterPage tools={TOOLS} />,
      },
      {
        path: 'password',
        element: <PasswordPage tools={TOOLS} />,
      },
      {
        path: 'percentage',
        element: <PercentagePage tools={TOOLS} />,
      },
      {
        path: 'yt-thumbnail',
        element: <YtThumbnailPage tools={TOOLS} />,
      },
      {
        path: 'text-to-speech',
        element: <TextToSpeechPage tools={TOOLS} />,
      },
      {
        path: 'qr-generator',
        element: <QrGeneratorPage tools={TOOLS} />,
      },
      {
        path: 'json-formatter',
        element: <JsonFormatterPage tools={TOOLS} />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
      },
      {
        path: 'terms-of-service',
        element: <TermsOfService />,
      },
      {
        path: 'about',
        element: <AboutUs />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
      {
        path: 'blog',
        element: <BlogListingPage />,
      },
      {
        path: 'blog/:slug',
        element: <BlogPostPage />,
      },
      {
        path: 'faq',
        element: <FAQPage />,
      },
      {
        path: 'help',
        element: <HelpPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
      {
        path: 'percentage-increase-calculator',
        element: <IncreasePercentage tools={TOOLS} />,
      },
      {
        path: 'percentage-decrease-calculator',
        element: <DecreasePercentage tools={TOOLS} />,
      },
      {
        path: 'discount-calculator',
        element: <DiscountCalculator tools={TOOLS} />,
      },
      {
        path: 'tax-calculator',
        element: <TaxCalculator tools={TOOLS} />,
      },
      {
        path: 'tip-calculator',
        element: <TipCalculator tools={TOOLS} />,
      },
      {
        path: 'marks-percentage-calculator',
        element: <MarksPercentage tools={TOOLS} />,
      },
      {
        path: 'gpa-calculator',
        element: <GpaCalculator tools={TOOLS} />,
      },
    ],
  },
])

const AppRouter = () => {
  return <RouterProvider router={router} />
}

export default AppRouter